module.exports = __webpack_public_path__ + "img/shining-nikki.298c319.png";